// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"Introduction_imgContainer__2D9ic","foodImg":"Introduction_foodImg__1WBHq","description-container":"Introduction_description-container__-Y8Y9"};